import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { BehaviorSubject } from 'rxjs';

const COMPANY_ROLE = 'COMPANY';

export interface AccountSetupState {
  loading: boolean;
  required: boolean;
}

@Injectable({ providedIn: 'root' })
export class AccountSetupService {
  private readonly stateSubject = new BehaviorSubject<AccountSetupState>({
    loading: true,
    required: false
  });

  readonly setupRequired$ = this.stateSubject.asObservable();

  constructor(private readonly keycloakService: KeycloakService) {}

  get isSetupRequired(): boolean {
    return this.stateSubject.value.required;
  }

  async check(): Promise<boolean> {
    const loggedIn = await this.keycloakService.isLoggedIn();
    if (!loggedIn) {
      this.stateSubject.next({ loading: false, required: false });
      return false;
    }

    const roles = this.keycloakService.getUserRoles();
    if (!roles.includes(COMPANY_ROLE)) {
      this.stateSubject.next({ loading: false, required: false });
      return false;
    }

    try {
      const profile: KeycloakProfile = await this.keycloakService.loadUserProfile();
      const attributes = (profile as KeycloakProfile & { attributes?: Record<string, unknown> }).attributes;
      const required = attributes?.['marketingAgreement'] == null;
      this.stateSubject.next({ loading: false, required });
      return required;
    } catch {
      this.stateSubject.next({ loading: false, required: false });
      return false;
    }
  }
}
